import React from 'react';
import { Button } from 'antd';
import { ISpecialty } from 'types/operation';
import s from './s.module.less';

interface IProps {
    index: number;
    specialty: ISpecialty;
    onEdit: (specialty: ISpecialty) => void;
}

const SpecialtyCard: React.FC<IProps> = ({ index, specialty, onEdit }) => {
    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <div className={s.title}>Specialty {index + 1}</div>
                <Button onClick={() => onEdit(specialty)}>Edit</Button>
            </div>
            <div className={s.content}>
                <div className={s.label}>Specialty</div>
                <div className={s.value}>{specialty.specialtyName}</div>
            </div>
        </div>
    );
};

export default SpecialtyCard;
